import { RemuneracaoMedica } from '@/types/core'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'CadastroLayoutEmailStore' })
export default class CadastroLayoutEmailStore extends VuexModule {
  public pagina: number = 1
  public emailLayoutInfo: any = {}
  public qtdPorPagina: number = 50
  public fontePagadora: string = ''
  public tipoNome: any = {}
  public assunto: string = ''
  public emailResposta: string = ''
  public emailContato: string = ''
  public emailCorpo: string = ''
  public emailRodape: string = ''
  public layoutEmailList: any[] = []
  public fontePagadoraList: any[] = []
  public tipoList: any[] = []
  public totalItems: number = 0
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setTotalItems(value: number) {
    this.totalItems = value
  }

  @Mutation
  setFontePagadora(value: string) {
    this.fontePagadora = value
  }

  @Mutation
  setTipoNome(value: any) {
    this.tipoNome = value
  }

  @Mutation
  setEmailAssunto(value: string) {
    this.assunto = value
  }

  @Mutation
  setEmailResposta(value: string) {
    this.emailResposta = value
  }

  @Mutation
  setEmailContato(value: string) {
    this.emailContato = value
  }

  @Mutation
  setEmailCorpo(value: string) {
    this.emailCorpo = value
  }

  @Mutation
  setEmailRodape(value: string) {
    this.emailRodape = value
  }

  @Mutation
  setLayoutEmailList(value: any[]) {
    this.layoutEmailList = value
  }

  @Mutation
  setFontePagadoraList(value: any[]) {
    this.fontePagadoraList = value
  }

  @Mutation
  setTipoList(value: any[]) {
    this.tipoList = value
  }

  @Mutation
  setEmailLayoutInfo(value: any) {
    this.emailLayoutInfo = value
  }

  @Mutation
  clearModalAddEdit() {
    this.fontePagadora = ''
    this.tipoNome = ''
    this.assunto = ''
    this.emailResposta = ''
    this.emailContato = ''
    this.emailCorpo = ''
    this.emailRodape = ''
  }

  @Action
  async getLayoutEmailList() {
    try {
      const response = await this.remuneracaoMedica.getLayoutEmailList()
      if (response.success) {
        this.context.commit('setLayoutEmailList', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async getFontePagadoraList() {
    try {
      const response = await this.remuneracaoMedica.getFontePagadoraAll()
      if (response.success) {
        this.context.commit('setFontePagadoraList', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async getTipoList() {
    try {
      const response = await this.remuneracaoMedica.getTipoList()
      if (response.success) {
        this.context.commit('setTipoList', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async getLayoutEmailById(params: any) {
    try {
      const response = await this.remuneracaoMedica.getLayoutEmailById(params)
      if (response.success) {
        this.context.commit('setEmailLayoutInfo', response.data)
        this.context.commit('setEmailAssunto', response.data.assunto)
        this.context.commit('setEmailResposta', response.data.emailResposta)
        this.context.commit('setEmailContato', response.data.emailContato)
        this.context.commit('setEmailCorpo', response.data.emailCorpo)
        this.context.commit('setEmailRodape', response.data.emailRodape)
      }
      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async salvarLayoutEmail() {
    try {
      const params = {
        hospitalId: this.emailLayoutInfo.hospitalId,
        tipo: this.tipoNome.key,
        assunto: this.assunto,
        emailResposta: this.emailResposta,
        emailContato: this.emailContato,
        emailCorpo: this.emailCorpo,
        emailRodape: this.emailRodape,
      }
      const response = await this.remuneracaoMedica.salvarLayoutEmail(params)
      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async criarLayoutEmail() {
    try {
      const params = {
        hospitalId: this.fontePagadora,
        tipo: this.tipoNome,
        assunto: this.assunto,
        emailResposta: this.emailResposta,
        emailContato: this.emailContato,
        emailCorpo: this.emailCorpo,
        emailRodape: this.emailRodape,
      }
      const response = await this.remuneracaoMedica.salvarLayoutEmail(params)
      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }
}
